import { createContext } from 'react';
export const OidcAuthContext = createContext(undefined);
const notLoaded = async () => {
    throw new Error('jaen: the OIDC runtime is not loaded on this route. This is a bug in ' +
        'needsOidcRuntime, which decides where it is needed.');
};
export const ANONYMOUS_AUTH = {
    isRuntimeLoaded: false,
    isAuthenticated: false,
    isLoading: false,
    user: null,
    error: undefined,
    activeNavigator: undefined,
    settings: { authority: __JAEN_ZITADEL_GQL__.authority },
    events: undefined,
    signinRedirect: notLoaded,
    signinPopup: notLoaded,
    signinSilent: notLoaded,
    signinResourceOwnerCredentials: notLoaded,
    signoutRedirect: notLoaded,
    signoutPopup: notLoaded,
    signoutSilent: notLoaded,
    removeUser: notLoaded,
    clearStaleState: notLoaded,
    querySessionStatus: notLoaded,
    revokeTokens: notLoaded,
    startSilentRenew: () => { },
    stopSilentRenew: () => { }
};
const OIDC_STORAGE_PREFIX = 'oidc.user:';
const hasStoredSession = (storage) => {
    if (!storage)
        return false;
    try {
        for (let index = 0; index < storage.length; index++) {
            const key = storage.key(index);
            if (key?.startsWith(OIDC_STORAGE_PREFIX))
                return true;
        }
    }
    catch {
        return false;
    }
    return false;
};
const AUTH_ROUTES = ['/login', '/signup', '/logout', '/cms', '/oidc'];
const AUTH_FLOW_ROUTES = ['/login', '/signup', '/logout', '/oidc'];
export const isAuthFlowRoute = (pathname) => {
    const withoutLocale = pathname.replace(/^\/[a-z]{2}(?=\/|$)/, '');
    return AUTH_FLOW_ROUTES.some(route => withoutLocale === route || withoutLocale.startsWith(`${route}/`));
};
export const needsOidcRuntime = (pathname) => {
    if (typeof window === 'undefined')
        return false;
    const path = pathname ?? window.location.pathname;
    if (hasStoredSession(window.sessionStorage) ||
        hasStoredSession(window.localStorage)) {
        return true;
    }
    const params = new URLSearchParams(window.location.search);
    if ((params.has('code') && params.has('state')) ||
        (params.has('error') && params.has('state'))) {
        return true;
    }
    const withoutLocale = path.replace(/^\/[a-z]{2}(?=\/|$)/, '');
    return AUTH_ROUTES.some(route => withoutLocale === route || withoutLocale.startsWith(`${route}/`));
};
const RETURN_TO_KEY = 'jaen:return-to';
export const rememberReturnTo = (path) => {
    try {
        if (isAuthFlowRoute(path)) {
            return;
        }
        sessionStorage.setItem(RETURN_TO_KEY, path);
    }
    catch {
    }
};
export const takeReturnTo = () => {
    try {
        const value = sessionStorage.getItem(RETURN_TO_KEY);
        sessionStorage.removeItem(RETURN_TO_KEY);
        return value;
    }
    catch {
        return null;
    }
};
